import { gql } from '@apollo/client';

export default gql`
  mutation UpdateTaxjarCheckoutLocation(
    $input: TaxjarCheckoutLocationUpdateInput!
  ) {
    updateTaxjarCheckoutLocation(input: $input) {
      partnerLocation {
        id
        name
        active
        taxjarCheckoutEnabled
      }
      errorMessages {
        code
        message
        path
      }
    }
  }
`;
